/**
 * Helpers for company_id / distributor_id on edit payloads.
 * Backend: omit key → keep existing; null / "" / 0 → clear link.
 */

/** Positive id only; undefined so JSON.stringify omits the key (preserve). */
export function positiveIdOrOmit(v: unknown): number | undefined {
  if (v == null || v === '') return undefined;
  const n = typeof v === 'number' ? v : Number(v);
  return Number.isFinite(n) && n > 0 ? n : undefined;
}

/**
 * Resolve a link id for PUT/edit bodies.
 * - cleared → null (backend clears)
 * - selected positive id → that id
 * - otherwise undefined (omit → backend preserves)
 */
export function resolveLinkId(
  selectedId: number | null | undefined,
  cleared: boolean
): number | null | undefined {
  if (cleared) return null;
  return positiveIdOrOmit(selectedId);
}
